<template>
  <div class="w-full justify-center min-h-full flex flex-col gap-y-4 max-w-4xl px-4 mx-auto">
    <template v-if="type == 'notFound'">
      <Icon class="text-8xl! text-gray-300">search</Icon>
      <p class="text-xl text-gray-700">
        {{ customMessage ? customMessage : $t('app.error.notFound') }}
        <BaseTextButton color="filled" @click="router.push({ name: 'dashboard' })">{{
          $t('common.home')
          }}</BaseTextButton>
      </p>
    </template>
    <template v-if="type == 'systemError'">
      <Icon class="text-8xl! text-gray-300">error</Icon>
      <p class="text-xl text-gray-700">
        {{ customMessage ? customMessage : $t('app.error.system') }}
      </p>
      <BaseTextButton color="filled" @click="router.push({ name: 'dashboard' })">{{
        $t('common.home')
        }}</BaseTextButton>
    </template>
    <template v-if="type == 'forbidden'">
      <Icon class="text-8xl! text-gray-300">lock</Icon>
      <p class="text-xl text-gray-700">
        {{ customMessage ? customMessage : $t('app.error.forbidden') }}
      </p>
      <BaseTextButton color="filled" @click="router.push({ name: 'dashboard' })">{{
        $t('common.home')
        }}</BaseTextButton>
    </template>
    <template v-if="type == 'unavailable'">
      <div class="relative h-24 w-24 mb-4">
        <BaseShape shape="12-sided-cookie" class="text-primary" />
        <Icon size="40" class="text-on-primary absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2">cloud_off
        </Icon>
      </div>
      <h3 class="text-headline-medium lg:text-display-medium text-gray-700">
        {{ customMessage ? customMessage : $t('app.error.unavailable') }}
      </h3>
      <p class="text-body-large text-on-surface-variant">Wir arbeiten bereits an einer Lösung. Bitte versuche es später
        erneut.</p>
      <div class="flex flex-row mt-10">

        <BaseButtonGroup>
          <BaseTextButton color="tonalPrimary" size="M" @click="goToMenonWebsite" trailingIcon="arrow_outward">
            Zur Menon Webseite
          </BaseTextButton>
          <BaseTextButton color="text" size="M" @click="router.push({ name: 'dashboard' })">
            Neu laden
          </BaseTextButton>
        </BaseButtonGroup>
      </div>
    </template>
    <template v-if="type == 'noOrganization'">
      <div class="relative h-24 w-24 mb-4">
        <BaseShape shape="12-sided-cookie" class="text-primary" />
        <Icon size="40" class="text-on-primary absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2">celebration
        </Icon>
      </div>
      <h3 class="text-headline-medium lg:text-display-medium text-gray-700">
        Willkommen bei Menon! 👋
      </h3>
      <p class="text-body-large text-on-surface-variant">
        Du bist aktuell noch keiner Organisation zugeordnet. Das können wir ändern:
      </p>
      <ul
        class="text-body-large text-on-surface-variant list-disc text-left max-w-xl ml-6 [&>li]:pl-1 flex flex-col gap-1">
        <li>
          <span class="font-bold">Neu hier?</span> Wenn du Menon für dein Team nutzen möchtest, <a class="underline"
            href="https://menon.group">kontaktiere uns</a>.
        </li>
        <li>
          <span class="font-bold">Team-Mitglied?</span> Falls du eigentlich schon dabei sein solltest, bitte deinen
          Teamlead, dich einzuladen.
        </li>
      </ul>
      <div class="flex flex-row mt-10">
        <BaseButtonGroup>
          <BaseTextButton color="tonalPrimary" size="M" @click="goToMenonWebsite" trailingIcon="arrow_outward">
            Zur Menon Webseite
          </BaseTextButton>
          <BaseTextButton color="text" size="M" @click="router.push({ name: 'dashboard' })">
            Neu laden
          </BaseTextButton>
        </BaseButtonGroup>

      </div>
    </template>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import Icon from '@/core/components/base/icon/BaseIcon.vue'
import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
import { useRouter } from 'vue-router'
import BaseShape from '@/core/components/base/shapes/BaseShape.vue'
import BaseButtonGroup from '@/core/components/base/button/BaseButtonGroup.vue'

interface Props {
  type: 'notFound' | 'systemError' | 'forbidden' | 'noOrganization' | 'unavailable'
  customMessages?: Map<'notFound' | 'systemError' | 'forbidden' | 'noOrganization' | 'unavailable', string>
}

const router = useRouter()

const props = defineProps<Props>()

const customMessage = computed(() => {
  if (props.customMessages) {
    return props.customMessages.get(props.type)
  }
  return undefined
})

const goToMenonWebsite = () => {
  location.href = 'https://menon.group'
}
</script>
